export function openCookiePreferences() {
    try {
        if (window._iub?.cs?.api && typeof window._iub.cs.api.openPreferences === 'function') {
            window._iub.cs.api.openPreferences();
            return;
        }
    } catch (e) {}

    const link = document.querySelector('a.iubenda-cs-preferences-link, .iubenda-cs-preferences-link');
    if (link) link.click();
}
